/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'edit... Remove this comment to see the full error message
import BaseRevisionsModal from 'editor-components/modals/EPRevisionsModal';
import UsageTracker from '../../utils/UsageTracker';
import { fetchVersions, restoreVersion } from '../../actions/edit/ArticleVersionsActions';
import ArticleVersionPreview from './ArticleVersionPreview';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ArticleVersionsModal(props) {
  const {
    articleId
  } = props;
  const dispatch = useAppDispatch();
  const articleVersions = useAppSelector(state => state.articleVersions).toJS();
  useEffect(() => {
    dispatch(fetchVersions(articleId, 0));
  }, [articleId, dispatch]);
  const loadMore = () => {
    dispatch(fetchVersions(articleId, articleVersions.offset + articleVersions.limit));
  };
  const onSelectVersion = selectedRevision => {
    dispatch(restoreVersion(articleId, selectedRevision.id));
  };
  return /*#__PURE__*/_jsx(BaseRevisionsModal
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'selectedVersionId' implicitly has... Remove this comment to see the full error message
  , {
    renderPreview: ({
      selectedRevision: {
        id: selectedVersionId
      }
    }) => /*#__PURE__*/_jsx(ArticleVersionPreview, {
      version: articleVersions.objects.find(rev => rev.id === selectedVersionId),
      templateSettings: props.templateSettings,
      linksColor: props.linksColor
    }),
    hasMoreRevisions: articleVersions.objects.length < articleVersions.total,
    onChooseRevision: onSelectVersion,
    onClose: props.onClose,
    onLoadMoreRevisions: loadMore,
    paginationLimit: articleVersions.limit,
    revisions: articleVersions.objects,
    totalRevisionCount: articleVersions.total,
    isLoadingInitialRevisions: !articleVersions.lastLoaded,
    usageTracker: UsageTracker
  });
}